import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BrowseDataSource, ColumnConfigModel, EnvironmentService, ToolbarService, TranslateService} from 'bos-commons';
import {Router} from '@angular/router';
import {HtmlAnchor} from './html-anchor';
import {TitleComponent} from '../title-component';

@Component({
  selector: 'app-admin-links',
  templateUrl: './admin-links.component.html',
  styleUrls: ['./admin-links.component.scss','../admin-footer/admin-footer.component.scss']
})
export class AdminLinksComponent extends TitleComponent{

  constructor(private httpClient: HttpClient,
              private environmentService: EnvironmentService,
              private translate: TranslateService,
              private router: Router,
              toolbarService: ToolbarService) {
    super(toolbarService, translate);
  }

  data: BrowseDataSource<HtmlAnchor>;
  columns = [
    new ColumnConfigModel({prop: 'id'}),
    new ColumnConfigModel({prop: 'locale', wrap: false}),
    new ColumnConfigModel({prop: 'anyLanguage', wrap: false, type: "BOOLEAN"}),
    new ColumnConfigModel({prop: 'name', wrap: false}),
    new ColumnConfigModel({prop: 'external', wrap: false, type: "BOOLEAN"}),
    new ColumnConfigModel({prop: 'url', wrap: false}),
    new ColumnConfigModel({prop: 'order', wrap: false})];

  getTitleKey() {
    return  'admin.footer.links';
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initialize();
  }

  private initialize() {
    const browseUrl = this.environmentService.environment.backendBaseUrl + this.environmentService.environment.allAdminAnchorsUrl;
    this.data = new BrowseDataSource<HtmlAnchor>(new Map<string, string>(), this.httpClient, browseUrl);
    this.columns.forEach(column => {
      column.label = this.translate.translateWithArgs('HtmlAnchor.' + column.prop);
    });
  }

  rowSelected($event: any) {
    this.router.navigate(['admin', 'view', 'HtmlAnchor', $event['id']]);
  }

  createNew() {
    this.router.navigate(['admin', 'view', 'HtmlAnchor', '0'])
  }

}
